import type { PCPDataContextType, PCPErrorType } from '@/constants/pcp/types';
import { pcpErrorTypeStrings } from '@/constants/pcp/types';
import { getPage } from '@/utils/pcp-helpers';
import { createContext } from 'react';
import Layout from './components/Layout';
import TestingMenu from './components/components/TestingMenu';
import Error from './content/Error';
import ConsultsComplete from './content/stages/ConsultsComplete';
import JourneyComplete from './content/stages/JourneyComplete';
import PreDoctor from './content/stages/PreDoctor';
import PreNurse from './content/stages/PreNurse';
import useUserData from './hooks/useUserData';

export const PCPDataContext = createContext<PCPDataContextType>({} as PCPDataContextType);

export default function PCPortal() {
  const dataContextValue = useUserData();
  const { testing, demoTesting, testPage, userData, userDataLoading, error } = dataContextValue;

  const page = getPage(userData, error);
  const targetPage = testing && demoTesting ? testPage : page;
  const isErrorTargetPage = (pcpErrorTypeStrings as readonly string[]).includes(targetPage);

  const getContent = () => {
    if (isErrorTargetPage) {
      return <Error type={targetPage as PCPErrorType} />;
    }

    switch (targetPage) {
      case 'blank':
        return null;
      case 'pre_nurse':
        return <PreNurse />;
      case 'pre_doctor':
        return <PreDoctor />;
      case 'consults_complete':
        return <ConsultsComplete />;
      case 'journey_complete':
        return <JourneyComplete />;
      default:
        return null;
    }
  };

  return (
    <PCPDataContext.Provider value={dataContextValue}>
      <Layout loading={userDataLoading}>{getContent()}</Layout>

      {testing && <TestingMenu />}
    </PCPDataContext.Provider>
  );
}
